var r=function(){for(var r={},a=0;a<arguments.length;a++){var o=arguments[a];for(var e in o)t.call(o,e)&&(r[e]=o[e])}return r},t=Object.prototype.hasOwnProperty;export{r as i};
